import { FilterConfig } from './usePaginatedFilters';

export const ALERT_TRIGGER_FILTER_CONFIGS: FilterConfig[] = [
  {
    type: 1, // Products
    key: 'products',
    label: 'Product',
    usePagination: true,
  },
  {
    type: 2, // Couriers
    key: 'filter_transport_providers',
    label: 'Transport provider',
    usePagination: false, // Couriers use existing Redux state
  },
  {
    type: 3, // Origins
    key: 'filter_origins',
    label: 'Origin',
    usePagination: true,
    filterType: 'origin',
  },
  {
    type: 4, // Destinations
    key: 'filter_destinations',
    label: 'Destination',
    usePagination: true,
    filterType: 'destination',
  },
  {
    type: 5, // Teams
    key: 'filter_teams',
    label: 'Teams',
    usePagination: false, // Teams use existing Redux state
  },
];

export const getFilterConfigByType = (
  type: number
): FilterConfig | undefined => {
  return ALERT_TRIGGER_FILTER_CONFIGS.find((config) => config.type === type);
};

export const getFilterConfigByKey = (key: string): FilterConfig | undefined => {
  return ALERT_TRIGGER_FILTER_CONFIGS.find((config) => config.key === key);
};
